import incrementingLoop from '@/workflow-runner/_data/visualSources/incrementing-loop-panels.json' with { type: 'json' };
import workflowTools from '@/workflow-runner/_data/visualSources/workflow-tools.json' with { type: 'json' };
import { parseWorkflowVisualSources } from '@/workflow-runner/_pure/episode';

export const workflowVisualSources = parseWorkflowVisualSources([incrementingLoop, workflowTools]);
